import React, { useContext } from "react";
import { Col, Image, Button, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { PRODUCT_ROUTE } from "../../utils/const";
import { Context } from "../../index";
import { Trash } from "react-bootstrap-icons";

const BasketItem = ({ basketProduct }) => {
  const navigate = useNavigate();
  const { product } = useContext(Context);

  const handleCountChange = (newCount) => {
    if (newCount >= 0) {
      product.changeCountBasketProduct(basketProduct, newCount);
    }
  };

  const totalPrice = (basketProduct.isSale ? basketProduct.salePrice : basketProduct.price) * basketProduct.count;

  return (
    <Row className="cart-product-line align-items-center mb-4 flex-column flex-md-row text-center text-md-start">
      <Col xs={12} md={1} className="mb-2 mb-md-0">
        <Image
          src={`${process.env.REACT_APP_API_URL_PROD}img/${basketProduct.image}`}
          className="thumb-img rounded-4"
          alt={basketProduct.name}
          style={{ cursor: "pointer", width: "80px", height: "80px", objectFit: "cover" }}
          onClick={() => navigate(PRODUCT_ROUTE + '/' + basketProduct.id)}
        />
      </Col>
      <Col xs={12} md={5} className="mb-2 mb-md-0">
        <h2 className="fs-6 mb-0">
          <span style={{ cursor: "pointer" }} onClick={() => navigate(PRODUCT_ROUTE + '/' + basketProduct.id)}>
            {basketProduct.name}
          </span>
        </h2>
        {basketProduct.isSale ? (
          <>
            <span className="basic_price text-danger me-2">{basketProduct.salePrice}₽</span>
            <span className="text-secondary text-decoration-line-through">{basketProduct.price}₽</span>
          </>
        ) : (
          <span className="basic_price">{basketProduct.price}₽</span>
        )}
      </Col>
      <Col xs={12} md={2} className="mb-2 mb-md-0">
        <div className="good-quantity-controler d-flex align-items-center justify-content-center justify-content-md-start">
          <Button
            variant="secondary"
            className="btn-controller mx-2 rounded-4"
            onClick={() => handleCountChange(basketProduct.count - 1)}
            disabled={basketProduct.count <= 1}
          >
            -
          </Button>
          <div className="good-quantity-controller__counter">
            {basketProduct.count}
          </div>
          <Button
            variant="secondary"
            className="btn-controller mx-2 rounded-4"
            onClick={() => handleCountChange(basketProduct.count + 1)}
          >
            +
          </Button>
        </div>
      </Col>
      <Col
        xs={12}
        md={2}
        className="text-center text-md-end order-1 order-md-5 mb-2 mb-md-0"
      >
        <span className="basic_price text-danger fs-5">{totalPrice}₽</span>
      </Col>

      {/* Кнопка удаления */}
      <Col
        xs={12}
        md={2}
        className="order-2 order-md-4 mb-2 mb-md-0"
      >
        <Button
          variant="outline-secondary"
          className="d-flex align-items-center justify-content-center w-100 btn-controller rounded-4"
          onClick={() => handleCountChange(0)}
        >
          <Trash className="me-2" /> Удалить
        </Button>
      </Col>
    </Row>
  );
};

export default BasketItem;
